/* eslint-disable camelcase */
import React from 'react';

import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';

import BuilderConstructorGrid from './BuilderConstructorGrid';
import BuilderConstructorGridV1_1 from './BuilderConstructorGridV1_1';
import BuilderConstructorGridV2 from './BuilderConstructorGridV2';

export * from './BuilderConstructorGrid.builder';

const BuilderConstructorGridSwitch = (props) => {
  const { enabled: isGridV1_1Enabled } = useHasFeature(
    featureNames.CONSTRUCTOR_GRID_V1_1
  );

  const { enabled: isGridV2Enabled } = useHasFeature(featureNames.GRID_V2);

  if (isGridV2Enabled) {
    return <BuilderConstructorGridV2 {...props} />;
  }

  if (isGridV1_1Enabled) {
    // eslint-disable-next-line react/jsx-pascal-case
    return <BuilderConstructorGridV1_1 {...props} />;
  }

  return <BuilderConstructorGrid {...props} />;
};

export default BuilderConstructorGridSwitch;
